import { useEffect, useState } from 'react';

export const useLazyCronometer = seconds => {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    if (!timeLeft || !isStarted) {
      setIsStarted(false);
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, isStarted]);

  const start = () => {
    setIsStarted(true);
  };

  const restart = () => {
    setTimeLeft(seconds);
    setIsStarted(true);
  };

  return [timeLeft, start, restart, isStarted];
};
